module.exports = __webpack_public_path__ + "static/media/goal.629ab95c.svg";